<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { DiscreteScaleLevelReadModel } from "@Scales/Domain/readmodels";

    @Component({
        props: {
            propValue: { type: Number, required: false },
            propComment: { type: String, required: false },
            propScaleLevels: { type: Array, required: true }
        }
    })
    export default class PanelistSurveyVoteEditorDr extends Vue
    {
        get value(): number | null { return this.$props.propValue as number | null; }
        get comment(): string | null { return this.$props.propComment as string | null; }
        get scaleLevels(): DiscreteScaleLevelReadModel[] { return this.$props.propScaleLevels as DiscreteScaleLevelReadModel[]; }

        IsSelected(val: number | null): boolean
        {
            return this.value === val;
        }

        updateValue(val: number | null)
        {
            if (val !== this.value)
            {
                this.$emit('update-value', val);
            }
            else
            {
                this.$emit('update-value', null);
            }           
        }

        updateComment(comment: string)
        {
            this.$emit('update-comment', comment);
        }
    }
</script>

<template>
    <div>
        <div class="list-group">
            <button v-for="l in scaleLevels" :key="l.Value" 
                    class="list-group-item list-group-item-action text-left" 
                    :class="{ 'active': l.Value === value }"
                    @click="updateValue(l.Value)">
                <i class="fa" :class="l.Value === value ? 'fa-check-circle' : 'fa-circle-thin'"></i>
                {{l.Name}} ({{l.Value}})
            <p class="mb-0" v-if="l.Definition">{{l.Definition}}</p>
            </button>
        </div>

        <textarea rows="3" :value.trim="comment" @input="updateComment($event.target.value)" class="form-control my-3" placeholder="Comment..."></textarea>
    </div>
</template>